__turbopack_context__.v({
  "container": "SwitchLanguageModal-module-scss-module__M4wL3a__container",
  "footer": "SwitchLanguageModal-module-scss-module__M4wL3a__footer",
  "languageButton": "SwitchLanguageModal-module-scss-module__M4wL3a__languageButton",
  "selected": "SwitchLanguageModal-module-scss-module__M4wL3a__selected",
});
